import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CoreInput } from 'components/core/library/input';
import { Label } from 'components/core/Label';

// REDUX-FORM TEXT INPUT
export default function TextInput({
	autoComplete,
	excludeError,
	className,
	helpText,
	input = {},
	label,
	labelFor,
	large,
	maxLength,
	meta = {},
	pattern,
	placeholder,
	readOnly,
	type = 'text',
	errorMessage
}) {
	return (
		<Label
			className={className}
			htmlFor={labelFor || input.name}
			text={label}
			helpText={helpText}
			textClassName="input"
		>
			<CoreInput
				{...input}
				className={
					classnames(
						{
							[`${type}-input-large`]: large,
							[`${type}-input-standard`]: !large,
							invalid: meta.touched && meta.error && !excludeError,
							valid: meta.touched && meta.valid
						}
					)
				}
				id={labelFor}
				autoComplete={autoComplete}
				placeholder={placeholder}
				pattern={pattern}
				maxLength={maxLength}
				type={type}
				valid={meta.valid}
				readOnly={readOnly}
			/>
			{meta.touched && meta.error && !excludeError &&
				<div className="input-error">
					{errorMessage || meta.error}
				</div>
			}
		</Label>
	);
}

TextInput.propTypes = {
	autoComplete: PropTypes.string,
	name: PropTypes.string,
	excludeError: PropTypes.bool,
	label: PropTypes.string,
	large: PropTypes.bool,
	input: PropTypes.object,
	inputClassName: PropTypes.string,
	className: PropTypes.string,
	helpText: PropTypes.string,
	pattern: PropTypes.string,
	placeholder: PropTypes.string,
	maxLength: PropTypes.number,
	type: PropTypes.string,
	meta: PropTypes.object,
	bindRef: PropTypes.func,
	labelFor: PropTypes.string,
	labelComponent: PropTypes.node,
	errorMessage: PropTypes.string,
	readOnly: PropTypes.bool
};

